// extracted by mini-css-extract-plugin
export default {"document":"Documents_document__aRl2p","icon":"Documents_icon__tNdli"};